import React from "react";
import { links } from "../data/content";
export const buttonBase = "inline-flex min-h-12 w-full items-center justify-center rounded-xl p-4 text-center text-base font-bold leading-snug transition-colors duration-150 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-4 focus-visible:ring-offset-ink";
export function PaymentButtons() {
  return <div className="mx-auto flex w-full max-w-[440px] flex-col gap-3" data-id="element-99" data-mp="1pgavfbetp4la">
      <a href={links.skool} target="_blank" rel="noopener noreferrer" className={`${buttonBase} bg-wa text-black hover:bg-wa-dark`} data-id="element-100" data-mp="1ufe02uqw58sq">
        Entrar con precio fundador — USD 27/mes
      </a>
      <a href={links.mercadopago} target="_blank" rel="noopener noreferrer" className={`${buttonBase} bg-mp text-white hover:bg-mp-dark`} data-id="element-101" data-mp="1kosrqflf0pwm">
        Pagar en Argentina — ARS 40.000/mes
      </a>
      <p className="text-sm leading-relaxed text-soft" data-id="element-102" data-mp="2d7g8jitdpirw">
        En USD, conocé la comunidad y suscribite desde Skool. En pesos, el enlace abre la suscripción de Mercado Pago.
      </p>
    </div>;
}